import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default function LinkTag({ url, externalLink, children, onClick, className }) {
  if (url.split('en/')[0] !== 'https://www.fanatical.com/') {
    if (externalLink) {
      return (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer nofollow"
          className={className}
          onClick={onClick}
        >
          {children}
        </a>
      );
    }

    return (
      <a
        href={url}
        className={className}
        onClick={onClick}
      >
        {children}
      </a>
    );
  }
  return (
    <Link
      to={`/${url.split('en/')[1]}`}
      className={className}
      onClick={onClick}
    >
      {children}
    </Link>
  );
}

LinkTag.propTypes = {
  url: PropTypes.string,
  externalLink: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
};

LinkTag.defaultProps = {
  url: '',
  externalLink: false,
  onClick: () => {},
};
